import React, { Component, ChangeEvent } from 'react';
import { Row, Col, Image, Form, FormCheck, FormControl } from 'react-bootstrap';
import { Answer } from '../../services/Learning';
import Utils from '../../services/Utils';
import { FaThumbsDown } from 'react-icons/fa';

export type IAnswersComponentProps = {
    answers: Answer[],
    multiAnswerAllowed: boolean,
    optionalAnswerAllowed: boolean,
    selectedAswersChanged: (selectedAnswers: (Answer | null) []) => void,
    optionalAnswersChanged: (optionalAnswers: string[]) => void,
    questionId: number // for reset selected answers on question change
}

type IAnswersComponentState = {
    selectedAnswers: (Answer | null)[];
    hasOptionalAnswer: boolean;
    optionalAnswers: string[]
}

class AnswersComponent extends Component<IAnswersComponentProps, IAnswersComponentState> {
    private questionId: number;

    constructor(props: IAnswersComponentProps) {
        super(props);

        this.state = {
            selectedAnswers: [],
            hasOptionalAnswer: false,
            optionalAnswers: []
        };

        this.props.selectedAswersChanged(this.state.selectedAnswers);
        this.props.optionalAnswersChanged(this.state.optionalAnswers);

        this.questionId = props.questionId;
    }

    componentWillReceiveProps(newProps: any) {
        if (this.questionId != newProps.questionId) {
            this.questionId = newProps.questionId;
            this.setState({selectedAnswers: [], optionalAnswers: []});
            this.props.selectedAswersChanged([]);
            this.props.optionalAnswersChanged([]);
        }
    }

    onChange = (index: number, el: React.FormEvent<HTMLInputElement>) => {
        let selectedAnswers: (Answer | null)[];
        if (this.props.multiAnswerAllowed) {
            this.state.selectedAnswers[index] = el.currentTarget.checked ? this.props.answers[index] : null;
            selectedAnswers = this.state.selectedAnswers;
        } else {
            selectedAnswers = [this.props.answers[index]];
            this.props.optionalAnswersChanged([]);
        }
        this.props.selectedAswersChanged(selectedAnswers);
        this.setState({
            hasOptionalAnswer: this.props.multiAnswerAllowed && this.state.hasOptionalAnswer,
            selectedAnswers
        });
    }

    onOptionalAnswerCheck = (el: React.FormEvent<HTMLInputElement>) => {
        if (!this.props.multiAnswerAllowed) {
            this.props.selectedAswersChanged([]);
            this.setState({selectedAnswers: []});
        }
        this.setState({hasOptionalAnswer: el.currentTarget.checked});
        this.props.optionalAnswersChanged(el.currentTarget.checked ? this.state.optionalAnswers : []);
    }

    onOptionalAnswerChange = (el: React.FormEvent<HTMLInputElement>) => {
        const optionalAnswers = this.state.optionalAnswers;
        optionalAnswers[0] = el.currentTarget.value;
        this.setState({optionalAnswers});

        this.props.optionalAnswersChanged(this.state.hasOptionalAnswer ? this.state.optionalAnswers : []);
    }

    render() {
        return (
            <Form>
                {(this.props.answers || []).map((answer, index) => 
                    <Row key={answer.id.toString()}>
                        <Col md={9}>
                            <Form.Check onChange={(el: React.FormEvent<HTMLInputElement>) => this.onChange(index, el)} name="ans" type={this.props.multiAnswerAllowed ? "checkbox" : "radio"} id={answer.id.toString()} label={<div dangerouslySetInnerHTML={{__html: answer.text}}></div>}></Form.Check>
                        </Col>
                        <Col md={3}>
                            {answer.image ? <Image src={Utils.getFileUrl(answer.image) || ''} width="100%" className={"answer-image"} /> : null}
                        </Col>
                    </Row>
                )}
                {this.props.optionalAnswerAllowed ? <>
                <Row>
                    <Col md={9} className="optional">
                        <Form.Check onChange={(el: React.FormEvent<HTMLInputElement>) => this.onOptionalAnswerCheck(el)} name="ans" type={this.props.multiAnswerAllowed ? "checkbox" : "radio"}/>
                        <Form.Group className="mb-0">
                            <Form.Control onChange={(el: React.FormEvent<HTMLInputElement>) => this.onOptionalAnswerChange(el)} placeholder="Произвольный ответ" as="textarea" rows={1}/>
                        </Form.Group>
                    </Col>
                </Row>
                </> : null}
            </Form>
        );
    }
}

export default AnswersComponent;
